/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const BoxExportIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Box Export',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m21.285 4.2-5.563-3.017a1.515 1.515 0 0 0-1.443 0L.409 8.7a.781.781 0 0 0 0 1.373L5.645 12.9ZM29.591 8.7l-5.149-2.794L8.8 14.615l6.2 3.357 14.591-7.9a.781.781 0 0 0 0-1.372ZM14 20.971 0 13.193v13.459a1.6 1.6 0 0 0 .823 1.4L14 35.371ZM28 24v-3.328a.5.5 0 0 1 .866-.341L36 28l-7.134 7.669a.5.5 0 0 1-.866-.341V32h-5a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1Z"
    />
    <path d="M27 18h3v-4.807l-14 7.778v14.4l4-2.222V23a1 1 0 0 1 1-1h5v-3a1 1 0 0 1 1-1Z" />
  </svg>`;
};
